import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { DollarSign, Sparkles, Info, Zap, Building2, GraduationCap } from "lucide-react";
import './ROSMAEditDialog.css';

const ROSMAEditDialog = ({ open, onOpenChange, investment, onSave }) => {
    const [newInvestment, setNewInvestment] = useState(investment);

    useEffect(() => {
        setNewInvestment(investment);
    }, [investment]);

    const handleSave = () => {
        onSave(newInvestment);
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="rosma-dialog">
                <DialogHeader>
                    <div className="rosma-icon-wrapper">
                        <DollarSign className="rosma-header-icon" />
                    </div>
                    <DialogTitle className="rosma-dialog-title">Edit Investment Amount</DialogTitle>
                    <DialogDescription className="rosma-dialog-desc">
                        Adjust the total investment to recalculate Return on Savings & Maturity Assessment
                    </DialogDescription>
                </DialogHeader>

                <div className="rosma-main-content">
                    <div className="rosma-input-group">
                        <Label htmlFor="investment" className="rosma-input-label">
                            <DollarSign className="rosma-label-icon" />
                            Total Investment Amount
                        </Label>
                        <div className="rosma-input-container">
                            <span className="rosma-currency">$</span>
                            <Input 
                                id="investment" 
                                type="number" 
                                step="1000" 
                                min="0" 
                                value={newInvestment} 
                                onChange={(e) => setNewInvestment(Number(e.target.value))}
                                className="rosma-number-input"
                            />
                            <span className="rosma-currency-label">USD</span>
                        </div>
                    </div>

                    <div className="rosma-info-section">
                        <div className="rosma-info-title-row">
                            <Info className="rosma-info-title-icon" />
                            <span className="rosma-info-title-text">Investment Breakdown</span>
                        </div>
                        <p className="rosma-info-subtitle">Typical AI implementation investment includes:</p>
                        
                        <div className="rosma-breakdown-grid">
                            <div className="rosma-breakdown-row">
                                <div className="rosma-breakdown-icon rosma-icon-blue">
                                    <Sparkles size={16} />
                                </div>
                                <span className="rosma-breakdown-label">AI platform & software licenses</span>
                                <span className="rosma-breakdown-value">40%</span>
                            </div>

                            <div className="rosma-breakdown-row">
                                <div className="rosma-breakdown-icon rosma-icon-purple">
                                    <Zap size={16} />
                                </div>
                                <span className="rosma-breakdown-label">Implementation & integration</span>
                                <span className="rosma-breakdown-value">30%</span>
                            </div>

                            <div className="rosma-breakdown-row">
                                <div className="rosma-breakdown-icon rosma-icon-pink">
                                    <GraduationCap size={16} />
                                </div>
                                <span className="rosma-breakdown-label">Training & change management</span>
                                <span className="rosma-breakdown-value">20%</span>
                            </div>

                            <div className="rosma-breakdown-row">
                                <div className="rosma-breakdown-icon rosma-icon-orange">
                                    <Building2 size={16} />
                                </div>
                                <span className="rosma-breakdown-label">Infrastructure & support</span>
                                <span className="rosma-breakdown-value">10%</span>
                            </div>
                        </div>
                    </div>
                </div>

                <DialogFooter className="rosma-dialog-footer">
                    <Button variant="outline" onClick={() => onOpenChange(false)} className="rosma-btn-cancel">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} className="rosma-btn-save">
                        <Sparkles size={16} />
                        Save Changes
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ROSMAEditDialog;